

























































































































































































































































































































































































































































































































































































































































































































































import { Component } from "vue-property-decorator";
import MapUI from "@/components/map/MapUI.vue";
import ControlsUI from "@/components/map/ControlsUI.vue";
import ScaleCoordinateUI from "@/components/map/ScaleCoordinateUI.vue";
import LegendUI from "@/components/map/LegendUI.vue";
import TreeListUI from "@/components/shared/TreeListUI.vue";
import PropertyUI from "@/components/shared/PropertyUI.vue";
import WindowUI from "@/components/shared/WindowUI.vue";
import DialogUI from "@/components/shared/DialogUI.vue";
import GISagroMap from "./gisagro.map.class";

import SearchMap from "./toc/search.map.vue";
import MapLayers from "./toc/map.layers.vue";
//import MapFilter from "./toc/map.filter.vue";
import DataFilter from "./toc/data.filter.vue";
import DataCalculator from "./toc/data.calculator.vue";

import Help from "./toc/help.vue";
import Login from "./toc/user.login.vue";
import UserProfile from "./toc/user.profile.vue";
import UserRegister from "./toc/user.register.vue";
import UserForgotPassword from "./toc/user.forgotpassword.vue";

import ImageCategory from "./toc/image.category.vue";
import ImageArchive from "./toc/image.archive.vue";
import ImageUploader from "./toc/image.uploader.vue";
import StationSummary from "./toc/station.summary.vue";
import StationCharts from "./toc/station.charts.vue";
import DiseaseCharts from "./toc/disease.charts.vue";
import DashboardMenu from "./toc/dashboard.menu.vue";
import Dashboard from "./toc/dashboard.vue";

import AdminUsers from "./toc/admin.users.vue";
import AdminAddUser from "./toc/admin.adduser.vue";
import AdminUserLogs from "./toc/admin.userlogs.vue";

@Component({
  components: {
    'ol-map': MapUI,
    'ol-controls': ControlsUI,
    'ol-scale-coordinate': ScaleCoordinateUI,
    'v-legend': LegendUI,
    'v-tree-list': TreeListUI,
    'v-property': PropertyUI,
    'v-window': WindowUI,
    'v-dialog': DialogUI,
    'search': SearchMap,
    'layers': MapLayers,
    'data_filter': DataFilter,
    'data_calculator': DataCalculator,
    'dashboard_menu': DashboardMenu,
    'dashboard': Dashboard,
    'help': Help,
    'login': Login,
    'user_profile': UserProfile,
    'user_register': UserRegister,
    'user_forgotpassword': UserForgotPassword,
    'image_category': ImageCategory,
    'image_archive': ImageArchive,
    'image_uploader': ImageUploader,
    'station_summary': StationSummary,
    'station_charts': StationCharts,
    'disease_charts': DiseaseCharts,
    'admin_users': AdminUsers,
    'admin_userlogs': AdminUserLogs,
    'admin_adduser': AdminAddUser
  }
})
export default class GISagro extends GISagroMap {
  //used for popup control
  get showBackdrop() : boolean {
    return this.$store.getters.ShowBackdrop;
  }
  set showBackdrop(value:boolean) {
    this.$store.commit('notifyChange', {
      ShowBackdrop: value
    });
  }

  // lifecycle methods
  created() {
    window.addEventListener('beforeunload', this.clearOpener);
    this.showDrawerLeft = !!this.toc;
    this.measurerIndex = 1;
    this.measurer = this.measurerStore.lists[this.measurerIndex];
    this.measureUnit = 'thai';
    this.measureCrs = 'WGS84';
    //this.fetchProvinces();
    //this.fetchCropFamilies();
    //this.fetchDeedTypes();
    this.fetchPageView('gisagro.map');
    //this.initMapLayer(); // moved to onMapCreated. we need to wait for data from server
  }

  mounted() {
    this.clockInterval = setInterval(() => {
      let d = new Date();
      let hh = ('0' + d.getHours()).slice(-2);
      let mm = ('0' + d.getMinutes()).slice(-2);
      let ss = ('0' + d.getSeconds()).slice(-2);
      let yy = d.getFullYear() + 543;
      let MM = ('0' + (d.getMonth() + 1)).slice(-2);
      let dd = ('0' + d.getDate()).slice(-2); 
      this.timeNow = dd + '-' + MM + '-' + yy + ' ' + hh + ':' + mm + ':' + ss;
    }, 1000);
  }

  beforeDestroy() {
    clearInterval(this.clockInterval);
  }

  letItHover() {
    //just make menu hover but do nothing
  }
}
